import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import "./css/layout.css";
import "./css/header.css";
import "./css/footer.css";
import "./css/button.css";
import "./css/homepage.css";
import "./css/dialog.css";
import "./css/buy-property.css";
import "./css/buy-property copy.css";
import "./css/dashboard.css";
import "./css/userLayout.css";
import "./css/my-property.css";
import "./css/agent.css";
import "./css/post-property.css";
import "./css/homeproperties.css";
import "./css/property-view.css";
import Route from "./route";
import { theme } from "./config/mui-theme";
import { ThemeProvider } from "@mui/material";
import "./lib/AxiosInterceptor";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router>
          <Route />
        </Router>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
